//let url = "https://" + window.location.host + "/moslcms/cms/";
let url = process.env.CMS_BASE_URL;
let baseAPI = process.env.REACT_APP_BASE_URL + '/';
// let baseAPI = "http://dxtechsol.com:8080/api/v1/";
// let baseAPI = "https://mf.moamc.com/mutualfund/api/v1/"
let baseAPINew = process.env.REACT_APP_API_BASE_URL;

export const endpoints = {
  baseUrl: process.env.REACT_APP_BASE_URL,
  app: {
    init: `${baseAPI}/init`,
  },
  user: {
    getUser: "/users",
  },
  login: {
    generateOtp: "/login/generateOtp",
    verifyOtp: "/login/authenticateUser",
    logout: "/login/logout",
    common: `${baseAPI}login/common`,
    menuRoleWise: "/menuRoleWise",
    getParams: "/getParams",
    authedicate: "/authedicate",
    masterMenu: "/masterMenu",
    SETMPIN: "/setmpin",
    getUserInfo: '/getuserinfo',
    GetOtpPreference: `${baseAPI}/GetOtpPreference`,
    GenrateMPINOTPValidate: '/c/login/GenrateMPINOTPValidate',
    GetGatewayData: `${baseAPI}/GetGatewayData`,
    GetTransactionSummaryDB: `${baseAPI}/GetTransactionSummaryDB`,
    GetUPIEmandateCount: `${baseAPI}/GetUPIEmandateCount`,
    initiateToken: `/handoff/initiate`,
  },
  additionalPurchase: {
    getFolioList: "/additionalPurchase/folioList",
  },
  preLogin: {
    internationalBusiness: `${baseAPI}getIntBusiness`,
    getAIFDetails: `${baseAPI}getAIFDetails`,
    aboutUs: `${baseAPI}Aboutus`,
    faq: `${baseAPI}getFAQ`,
    NavDetail: `${baseAPI}NAVDetails`,
    HistoricalFilter: `${baseAPI}HistoricalFilter`,
    MFHome: `${baseAPI}MFHome`,
    passiveHome: `${baseAPI}PassiveFundHome`,
    fundDetail: `${baseAPI}FundDetail`,
    InactivefundDetail: `${baseAPI}InactiveFundDetail`,
    //fundDetail:'https://mf.moamc.com/mutualfund/api/v1/FundDetail',
    FundCategory: `${baseAPI}FundCategory`,
    FundCategoryNew: `${baseAPI}FundCategoryNew`,
    // FundCategoryNew: 'https://mf.moamc.com/mutualfund/api/v1/FundCategoryNew',
    // FundCategoryNew: 'https://www.motilaloswalmf.com/mutualfund/api/v1/FundCategoryNew',
    getAllFunds: `${baseAPI}getAllFundsBoost`,//getAllFunds
    getFundsCategorisation: `${baseAPI}getFundsCategorisationNode`, //getFundsCategorisation
    getFundsCategorisation2: `${baseAPINew}/CRM/api/CRM/GetFundFilter`,
    STPCategory: `${baseAPI}SchemesForSTP`,
    GetFundsForFilter: `${baseAPI}GetFundsForFilter`,
    CompareFunds: `${baseAPI}CompareFunds`,
    download: `${baseAPI}getDownloads`,
    SearchDownloads: `${baseAPI}SearchDownloads`,
    ContactUs: `${baseAPI}ContactUs`,
    enquiry: `${baseAPI}enquiry`,
    perforamceGraph: `${baseAPI}PerformanceGraph`,
    perforamceGraphNew: `${baseAPI}PerformanceGraphNew`,
    PMSCategory: `${baseAPI}PMSFundCategory`,
    PMSGraphData: `${baseAPI}PMSGraphData`,
    PMSFundDetail: `${baseAPI}PMSFundDetail`,
    getSchemesForSEO: `${baseAPI}getSchemesForSEO`,
    getInactiveSchemesForSEO: `${baseAPI}getInactiveSchemesForSEO`,
    getTotalExpratio: `${baseAPI}getTotalExpratio`,
    WPposts: `${baseAPI}WPposts`,
    WPPostMedia: `${baseAPI}WPPostMedia`,
    getGeneralBanners: `${baseAPI}getGeneralBanners`,
    ValidatePIN : `${baseAPINew}/PreLogin/api/PreLogin/ValidatePincode`


  },
  ob: {
    masters: `${baseAPI}ob/getMasters`,
    common: `${baseAPI}ob/common`,
    ifscBankDet: `${baseAPI}ob/getBankFromIFSC`,
  },
  trans: {
    common: `${baseAPI}trans/common`,
    commonGet: `${baseAPI}trans/commonGet`,
    commonNew: `${baseAPI}trans/commonNew`,
    StopAccountDetails: `/c/trans/StopAccountDetails`,
  },
  extra: {
    GetSchemeDetForSIPDashboard: `${baseAPI}/GetSchemeDetForSIPDashboard1`,
    getSchemeName: `${baseAPI}/getSchemeName1`,
  },
  checkCookies: `${baseAPI}chklogin`,
  emandate: {
    emandate: "/emandate",
    confirmEmandate: "/confirmEmandate",
    razorpayStatus: "/razorpayStatus",
  },
  quickbuy: {
    FolioListKarvy: `/FolioListKarvy`,
    GetRegisteredBanks: `/GetRegisteredBanks`,
    OrderGeneration: `/OrderGeneration`,
    PaymentRequest: `/PaymentRequest`,
    GetPGResponse: `/GetPGResponse`,
    validateBrokerCode: `/validateBrokerCode`,
    folioBrokerList: `/folioBrokerList`,
    razorpaySaveOrder: `/razorpaySaveOrder`,
    razorpayOrderGeneration: `/razorpayOrderGeneration`,
    GetPGConfirmationdata: `/GetPGConfirmationdata`,

    RetryPaymentWB: `/transaction/retryPayment`,
    GetPGResponseWB: `/GetPGResponseWB`,
    GetPGConfirmationdataWB: `/GetPGConfirmationdataWB`,
    
    // Journey tracking endpoints (same as SipHouse)
    SaveBasicDetailsScreenOne: '/c/sipHouse/SaveBasicDetailsScreenOne',
    SaveBoosterDetailsScreenTwo: '/c/sipHouse/SaveBoosterDetailsScreenTwo', 
    SaveBankDetailsScreenThree: '/c/sipHouse/SaveBankDetailsScreenThree',
  },
  quickbuy2: {
    FolioListKarvy: `${baseAPI}FolioListKarvy`,
    GetRegisteredBanks: `${baseAPI}GetRegisteredBanks`,
    OrderGeneration: `${baseAPI}OrderGeneration`,
    PaymentRequest: `${baseAPI}PaymentRequest`,
    GetPGResponse: `${baseAPI}GetPGResponse`,
    validateBrokerCode: `${baseAPI}validateBrokerCode`,
    folioBrokerList: `${baseAPI}folioBrokerList`,
    razorpaySaveOrder: `${baseAPI}razorpaySaveOrder`,
    razorpayOrderGeneration: `${baseAPI}razorpayOrderGeneration`,
    GetPGConfirmationdata: `${baseAPI}GetPGConfirmationdata`,
  },
  ri: {
    GetRedemptionIntervention: "/GetRedemptionIntervention",
    GenerateRedeemOTPBucketID: "/GenerateRedeemOTPBucketID",
    SaveBasketRedemptionTransaction: "/SaveBasketRedemptionTransaction",
    ValidateRedeemOTP: "/ValidateRedeemOTP",
    RedemptionCancellation: "/RedemptionCancellation",
    GenerateRedemptionInvestorOTPBucketId:
      "/GenerateRedemptionInvestorOTPBucketId",
  },
  reportsV2: {
    elssReportData: "/c/reportsV2/elssReportData",
    elssReportPdfDownload: "/c/reportsV2/elssReportPdfDownload",
  },
  fabPlans: {
    fabScheme: "/c/cms/fabScheme",
    CashFlowCalculatorFrequency: "/c/fabPlan/CashFlowCalculatorFrequency",
    folioDetails: "/c/fabPlan/folioDetails",
    withdrawPlotting: "/c/fabPlan/withdrawPlotting",
    getGenerateFabLink: '/getGenerateFabLink',
    getAggGenerateFabLink: '/getAggGenerateFabLink'
  },
  reports: {
    bitlyLink: `/bitlyLink`,
    reportSend: `/c/reports/reportSend`,
  },
  unclaimed: {
    GetUnclaimedDropDown: '/c/unclaimed/GetUnclaimedDropDown',
    GetUnclaimedFolioPan: '/c/unclaimed/GetUnclaimedFolioPan',
    GetUnclaimedDetails: '/c/unclaimed/GetUnclaimedDetails',
  },
  logout: {
    removeCookie: '/removeCookie'
  },
  sipHouse: {
    SaveBasicDetailsScreenOne: '/c/sipHouse/SaveBasicDetailsScreenOne',
    SaveBoosterDetailsScreenTwo: '/c/sipHouse/SaveBoosterDetailsScreenTwo',
    SaveBankDetailsScreenThree: '/c/sipHouse/SaveBankDetailsScreenThree',
    GetSIPInHouseDetails: '/GetSIPInHouseDetails',
    GetKfinOrderList: '/kfin/list',
    GetKfinBankData: '/kfin/bankData'
  },
  nav: {
    GetNavApplicability: '/kfin/nav-applicability'
  }
};
